module.exports = __webpack_public_path__ + "static/img/12.12a0418.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/eng/12.png
// module id = 961X
// module chunks = 0